import { Table, TableContainer } from '@material-ui/core';
import { PaymentAttempt } from '@nemuru-eng/js-api-client';

import { PaymentAttemptsTableBody } from '@/components/modules/PaymentAttempts/shared/components/PaymentAttemptsTableBody';
import { PaymentAttemptsTableHeader } from '@/components/modules/PaymentAttempts/shared/components/PaymentAttemptsTableHeader';

interface PaymentAttemptsProps {
  paymentAttempts: PaymentAttempt[];
}

export const PaymentAttempts = ({ paymentAttempts }: PaymentAttemptsProps) => {
  return (
    <TableContainer id={'table-container'}>
      <Table>
        <PaymentAttemptsTableHeader />
        <PaymentAttemptsTableBody paymentAttempts={paymentAttempts} />
      </Table>
    </TableContainer>
  );
};
